import { render, staticRenderFns } from "./ManageBDX.vue?vue&type=template&id=2e8473bd&scoped=true"
import script from "./ManageBDX.vue?vue&type=script&lang=js"
export * from "./ManageBDX.vue?vue&type=script&lang=js"
import style0 from "./ManageBDX.vue?vue&type=style&index=0&id=2e8473bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8473bd",
  null
  
)

export default component.exports